:host {
  display: block;
}

h4 {
  font-family:'Lato';
  font-weight:'regular';
  line-height:120%;
  font-size:36px;
  letter-spacing:0.5;
  text-decoration:none;
}
